import React, { Component } from "react";

export class BaseFilterController {
    searchQuery: string = "";
    onRefresh: () => void;
    constructor(onRefresh: () => void) {
        this.onRefresh = onRefresh;
    }
}

export interface Props {
    controller: BaseFilterController;
}

/** Generic search filter bar with text input and auto-refresh. */
export class BaseFilter extends Component<Props> {
    static displayName = BaseFilter.name;
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="mb-3" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <div style={{ flexGrow: 1, marginRight: 32 }}>
                    <label htmlFor="base-filter-search" className="mr-2" style={{ marginRight: 8 }}>Search</label>
                    <input
                        id="base-filter-search"
                        aria-label="Search"
                        value={this.props.controller.searchQuery}
                        onChange={(data) => {
                            this.props.controller.searchQuery = data.currentTarget.value;
                            this.setState({}, this.props.controller.onRefresh);
                        }}
                        className="border rounded px-3 py-1"
                        style={{ width: "100%", maxWidth: 400 }}
                    />
                </div>
            </div>
        );
    }
}
